/**
 * Item route helpers for MobileShell bespoke swaps.
 */
import { isUuid } from '../lib/isUuid';

const ITEM_DETAIL_RE = /^\/prioritization\/items\/([^/]+)$/;

/**
 * Parse /prioritization/items/<id> into an item id, or null.
 *
 * Named sibling routes (/items/triage, /items/types, /items/whiteboards, …)
 * and junk segments ("/items/intake") share this URL shape but are not item
 * ids — items.id is uuid-typed, so treating them as ids fires a doomed DB
 * query. Only UUID-shaped segments count; everything else falls through to
 * the desktop router (same approach as parseStrategyDetailPath).
 */
export function parseItemDetailPath(pathname: string): string | null {
  const segment = ITEM_DETAIL_RE.exec(pathname)?.[1];
  if (!segment || !isUuid(segment)) return null;
  return segment;
}
